<span class="breadcrumbs">
    <span *ngFor="let breadcrumb of breadcrumbs; let i = index">
        <a class="breadcrumb-style" *ngIf="i < breadcrumbs.length - 1" [routerLink]="breadcrumb.url">{{ breadcrumb.name }}</a>
        <span *ngIf="i === breadcrumbs.length - 1" class="last-breadcrumb">{{ breadcrumb.name }}</span>
        <span *ngIf="i < breadcrumbs.length - 1">&nbsp;/&nbsp;</span>
      </span>
</span>